/* ============================================
   MAIN ENTRY POINT
   The Creative Orchestra - GEMINI Framework
   Application bootstrap and initialization
   ============================================ */

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// Import global styles
import '@styles/index.css';
import '@styles/animations.css';

// Feature detection and polyfills
const initApp = () => {
  // Check for required browser features
  const requiredFeatures = {
    localStorage: 'localStorage' in window,
    fetch: 'fetch' in window,
    promises: 'Promise' in window,
  };

  const missingFeatures = Object.entries(requiredFeatures)
    .filter(([_, supported]) => !supported)
    .map(([feature]) => feature);

  if (missingFeatures.length > 0) {
    console.warn('Missing browser features:', missingFeatures);
  }

  // Performance monitoring (development only)
  if (import.meta.env.DEV) {
    // Log render timing
    const startTime = performance.now();
    
    window.addEventListener('load', () => {
      const loadTime = performance.now() - startTime;
      console.log(`⚡ App loaded in ${loadTime.toFixed(2)}ms`);
    });
  }
};

// Initialize app features
initApp();

// Render application
ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Hot Module Replacement (HMR) for development
if (import.meta.hot) {
  import.meta.hot.accept();
}
